module.exports = __webpack_public_path__ + "img/72_1.7e6589ce.png";